import type { CalendarView } from '@/api/resourceCalendarApi'
import { TypeBadge } from './ActivityCard'

/** Every type the calendar can show, with its name — a quiet strip under the grid. */
export function ActivityLegend({ legend }: { legend: CalendarView['legend'] }) {
  return (
    <ul
      aria-label='Activity types'
      className='flex shrink-0 flex-wrap items-center gap-x-4 gap-y-1 px-1 text-[11px] text-muted-foreground'
    >
      {legend.map((t) => (
        <li key={t.code} className='flex items-center gap-1.5'>
          <TypeBadge code={t.code} />
          <span>{t.name}</span>
        </li>
      ))}
    </ul>
  )
}
